import Vue from 'vue'
import Router from 'vue-router'

import Login from '../pages/Login';

import content_cont from '../pages/Content';
import DashboardLayout from "../pages/DashboardLayout.vue";
import Dashboard from './../pages/Dashboard';
import Profile from "../pages/Profile";
import Users from "../pages/Users";
import Equipment from "../pages/Equipment";
import Tasks from "../pages/Tasks";
import Maintenance from "../pages/Maintenance";
import Appeals from "../pages/Appeals";

import Product from "../pages/Product";
import Parking from "../pages/Parking";
import Audit from "../pages/Audit";
import auditNew from "../pages/CheckList";
import control from "../pages/Control";
import Appeal from "../pages/Appeal";
import recoverPassword from "../pages/recover-password";
import addSerial from "../pages/addSerial";
import activation from "../pages/activation";

//import chat from "../pages/chat";

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        /*{
            path: "/",
            name: "login",
            component: Login,
            meta: { title: 'Login' },
        },*/
        {
        path: "/",
        name: "dashboard-layout",
        redirect: { name: 'dashboard' },
        component: DashboardLayout,
        meta: { title: 'Dashboard' },
        children: [
           {
                path: "/",
                component: content_cont,
                children: [
                    {
                        path: "/",
                        name: "login",
                        component: Login,
                        meta: { title: 'Login' },
                    },
                    {
                        path: "recover-password/:token?",
                        name: "recover-password",
                        component: recoverPassword,
                        meta: { title: 'Password recovering' },
                    },
                    {
                        path: 'main',
                        name: 'dashboard',
                        component: Dashboard,
                        meta: { title: 'Dashboard' }
                    },
                    {
                        path: 'profile',
                        name: 'profile',
                        component: Profile,
                        meta: { title: 'Profile' }
                    },
                    {
                        path: 'users',
                        name: 'users',
                        component: Users,
                        meta: { title: 'Users' }
                    },
                    {
                        path: 'tasks/:guidTask?',
                        name: 'tasks',
                        component: Tasks,
                        meta: { title: 'Tasks' }
                    },
                    {
                        path: 'equipment/:serial?',
                        name: 'equipment',
                        component: Equipment,
                        meta: { title: 'Equipment' }
                    },
                    {
                        path: 'activation',
                        name: 'activation',
                        component: activation,
                        meta: { title: 'Activation' }
                    },
                    {
                        path: 'Appeals/:guidApp?',
                        name: 'appeals',
                        component: Appeals,
                        meta: { title: 'Appeals'},
                    }
                    
                ]
            }
        ]
        },
        {
            path: "/product/:serial?",
            name: "product",
            component: Product,
            meta: { title: 'Product' },
        },
        {
            path: "/audit",
            name: "audit",
            component: Audit,
            meta: { title: 'audit' },
        },
        {
            path: "/check",
            name: "check",
            component: auditNew,
            meta: { title: 'CheckList'},
        },
        {
            path: "/control/:parameter?",
            name: "control",
            component: control,
            meta: { title: 'CheckList'},
        },
        {
            path: "/parking",
            name: "parking",
            component: Parking,
            meta: { title: 'Parking' },
        },
        {
            path: "/not-found",
            alias: '*',
            //component: { render: (h) => h("div", ["404! Page Not Found!"]) },
            component: Maintenance,
            meta: { title: 'Not Found' },
        },
        {
            path: "/appeal/:serial?",
            name: "appeal",
            component: Appeal,
            meta: { title: 'Appeal' },
        },
        {
            path: '/addSerial',
            name: 'addSerial',
            component: addSerial,
            meta: { title: 'Add Serial'},
        }
    ],
    //linkActiveClass: "active",
})



// WEBPACK FOOTER //
// ./src/router/index.js